import React, { useContext, useEffect, useState } from "react";
import styles from './style.module.css';
import { AuthContext } from "../../authContext";
import useStore from "../../store/store";
import serverPath from "../../utils/serverPath";
import { NavLink } from "react-router-dom";
const Gifts = (props) =>
{
    const context = useContext(AuthContext);
    const [globalState] = useStore();
    const {gifts} = globalState;

    useEffect(() =>
    {
      if(gifts.length > 0)
      {
        window.loadTable();
      }
      // window.loadForm();
    }, [gifts])

    return (
      <div className="main-content">
        <section className="section">
          <div className="section-body">
            <div className="row">
              <div className="col-12">
              <div className="card">
                  <div className="card-header">
                    <h4>Your Gifts</h4>
                  </div>
                  <div className="card-body">
                    <div className="table-responsive">
                      <table className="table table-striped" id="table-1">
                        <thead>
                          <tr>
                            <th className="text-center">
                              #
                            </th>
                            <th>Name</th>
                            <th>Image</th>
                            <th>Date</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {gifts.map((perField, index) => {
                          return (
                          <tr key={perField.id}>
                            <td>
                              {(index + 1)}
                            </td>
                            <td>{perField.name}</td>
                            <td>
                              <a alt="image" href={serverPath(perField.photo)} target="_blank">Preview</a>
                            </td>
                            <td>{(new Date(perField.createdAt).toLocaleDateString())?.replace(/\//ig, "-")}</td>
                            <td><NavLink to={`/gift/edit/${perField.id}`} className="btn btn-primary">Edit / Delete</NavLink></td>
                          </tr>
                          )})}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </div>
        </section>
      </div>
    )
}


export default Gifts;